import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main id="main-content" className="not-found">
      <img src="/brand/marky-solid.svg" alt="" aria-hidden="true" />
      <p>That page is not part of the system.</p>
      <h1>Let us get you back somewhere useful.</h1>
      <Link className="button button--forest" to="/">Return home <span aria-hidden="true">↗</span></Link>
    </main>
  );
}
